import React from "react";
import Les1 from "./page/les1";
import Les2 from "./page/les2";
import Les3 from "./page/les3";
import Les4 from "./page/les4";
import Les5 from "./page/les5";
import { BrowserRouter as Router, Route } from "react-router-dom";
import RoutIndex from "./page/Signup"

export default function App() {
  return (
    <div style={{ textAlign: "center" }}>
    <Router>
      <div>
        <Route exact path="/" component={RoutIndex} />
        <Route exact path="/register" component={Les1} />
      </div>
    </Router>
    </div>
    // <div style={{ textAlign: "center" }}>
    //   {/* <h1>Linelogin</h1>
    //   <p>____________________________</p>
    //   <Les1 />
    //   <br /> */}
    //   {/* <h1>Lession 2</h1>
    //   <p>____________________________</p> */}
    //   {/* <Les1 /> */}
    //   <Signup />
    //   {/* <br />
    //   <h1>Lession 3</h1>
    //   <p>____________________________</p>
    //   <Les3 />
    //   <br />
    //   <h1>Lession 4</h1>
    //   <p>____________________________</p>
    //   <Les4 />
    //   <br />
    //   <h1>Lession 5</h1>
    //   <p>____________________________</p>
    //   <Les5 /> */}

    //   <br />
    // </div>
  );
}



// WEBPACK FOOTER //
// src/App.js